import { jsx as o } from "react/jsx-runtime";
import { aP as e } from "../../../vendor-Dd6qj6gJ.js";
import { DotProgress as t } from "../../DotProgress/index.js";
import '../../../assets/index46.css';const d = "_loadMoreItem_38q9n_4", c = "_loadMoreIndicator_38q9n_17", r = {
  loadMoreItem: d,
  loadMoreIndicator: c
};
function m(a) {
  return /* @__PURE__ */ o(e, { className: r.loadMoreItem, ...a, children: /* @__PURE__ */ o("div", { className: r.loadMoreIndicator, children: /* @__PURE__ */ o(t, { "aria-label": "Loading more options..." }) }) });
}
export {
  m as LoadMoreItem
};
